// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1jzMu","label":"Labeled_label__1_4Ds","divider":"Labeled_divider__1Qe8F"};